import { ApiKeyId, ApiKeyResponse } from '@business/entities/apikey';
import { Endpoint } from '../endpoint';

export function fetchApiKeys() {
  return Endpoint.get<ApiKeyResponse[]>(`@gc/apikey`);
}

export function createApiKey(title: string) {
  return Endpoint.post<ApiKeyResponse>(`@gc/apikey`, { data: { title } });
}

export function toggle(id: ApiKeyId) {
  return Endpoint.patch<ApiKeyResponse>(`@gc/apikey/toggle/${id}`);
}

export function editApiKey(id: ApiKeyId, title: string) {
  return Endpoint.patch<ApiKeyResponse>(`@gc/apikey/${id}`, { data: { title } });
}

export function deleteApiKey(id: ApiKeyId) {
  return Endpoint.delete<void>(`@gc/apikey/${id}`);
}
